import { Document } from "@contentful/rich-text-types";
import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer";

export function pluralMin(min: number): string {
  return min <= 1 ? "min" : "mins";
}

export function friendlyDate(date: string) {
  const options = { year: "numeric", month: "long", day: "numeric" } as const;
  const timestamp = Date.parse(date);

  return new Date(timestamp).toLocaleDateString("en-US", options);
}

export function readingTime(content: Document): number {
  const WORDS_PER_MINUTE = 238;
  const wordParser = /\w+/g;
  const contentString = documentToPlainTextString(content);

  const wordCount = contentString.match(wordParser)?.length || 1;

  return Math.ceil(wordCount / WORDS_PER_MINUTE);
}
